import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { useRecoilState, useRecoilValue } from "recoil";
import { useLocation, useNavigate } from "react-router-dom";
import StoreController, {
  CategoryType,
  ProductType,
  StoreType,
} from "../../controller/StoreController";
import {
  getCartLength,
  orderDetailOptionType,
  orderDetailRealmType,
} from "../../recoil/cart";
import AsyncLocalStorage from "../../util/AsyncLocalStorage";
import { OptionModalType, optionModalState } from "../../recoil/optionModal";
import { useToast } from "../../controller/ToastController";
import RecoilOptionModal from "../../components/modal/RecoilOptionModal";

let timer: any;

const OrderMain = () => {
  const [storeInfo, setStoreInfo] = useState<StoreType>();

  const showToast = useToast();

  const navigate = useNavigate();
  const location = useLocation();
  const storeId = location.state?.store_id;
  // const storeId = 210; //test

  const [selectedCategoryId, setSelectedCategoryId] = useState<number>(0);

  const [isScroll, setIsScroll] = useState<boolean>(false);
  const [visibleCart, setVisibleCart] = useState<boolean>(true);

  const categoryScrollRef = useRef<HTMLDivElement>(null);
  const scrollRef = useRef<HTMLDivElement>(null);

  const [cart, setCart] = useState<orderDetailRealmType[]>([]);

  const [modalOpen, setModalOpen] =
    useRecoilState<OptionModalType>(optionModalState);

  // API 호출
  const getStoreInfo = async () => {
    try {
      const oParams = {
        store_id: storeId,
      };
      const oRes = await StoreController.getMenu(oParams);

      if (oRes && oRes.data) {
        console.log("getMenu", oRes.data);
        setStoreInfo(oRes.data.content);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const getProductOption = async (product_id: number) => {
    try {
      const oParams = {
        store_id: storeId,
        product_id: product_id,
      };
      const oRes = await StoreController.getOptions(oParams);
      if (oRes && oRes.data) {
        console.log("getOptions", oRes.data);
        return oRes.data.options;
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const setFavorite = async () => {
    try {
      if (storeInfo) {
        const oParams = {
          store_id: storeInfo.extra.store_id,
          favorites_flag: storeInfo.favorites_flag === 1 ? 0 : 1,
        };
        const oRes = await StoreController.setFavoritesStore(oParams);

        if (oRes && oRes.data && oRes.data.success) {
          console.log("setFavoritesStore", oRes.data);
          setStoreInfo({
            ...storeInfo,
            ...{ favorites_flag: storeInfo.favorites_flag === 1 ? 0 : 1 },
          });
          console.log({
            ...storeInfo,
            ...{ favorites_flag: storeInfo.favorites_flag === 1 ? 0 : 1 },
          });
        }
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };

  const addCartData = (
    product: ProductType,
    option?: orderDetailOptionType[]
  ) => {
    let aCartTemp: any = [];
    if (cart && Array.isArray(cart)) {
      aCartTemp = [...cart];
    }

    let searchIndex = -1;
    if (aCartTemp && aCartTemp.length > 0) {
      searchIndex = aCartTemp.findIndex(
        (item: any) => item.product_id === product.prd_id
      );
    }

    if (searchIndex === -1 || option) {
      const cartData: orderDetailRealmType = {
        store_id: storeId,
        product_id: product.prd_id,
        product_name: product.prd_name,
        product_org_price: Number(product.prd_org_price),
        product_quantity: 1,
        product_total_amount: Number(product.prd_base_price),
        options: option ? option : [],
      };
      aCartTemp.push(cartData);
    } else if (aCartTemp && aCartTemp.length > 0) {
      aCartTemp[searchIndex].product_quantity += 1;
    }
    if (aCartTemp && aCartTemp.length > 0) {
      setCart([...aCartTemp]);
    }
    AsyncLocalStorage.setItem(
      "cart",
      JSON.stringify({
        store_id: storeId,
        data: aCartTemp,
      })
    );
  };

  const checkCartOption = async (categoryId: number, product: ProductType) => {
    const options = await getProductOption(product.prd_id);
    const productOption: orderDetailOptionType[][] = Object.keys(options).map(
      (key) => options[key]
    );
    console.log("productOption", productOption);
    if (productOption.length > 0) {
      setModalOpen({
        visibleConfirm: true,
        handleConfirm: addCartData,
        title: product.prd_name,
        modalData: {
          category_id: categoryId,
          product: product,
          option: productOption,
        },
      });
    } else {
      addCartData(product);
    }
  };

  const setQuantity = (index: number, quantity: number) => {
    console.log("cart", cart);
    if (quantity < 1) {
      cart.splice(index, 1);
    } else {
      cart[index].product_quantity = quantity;
    }
    setCart([...cart]);

    AsyncLocalStorage.setItem(
      "cart",
      JSON.stringify({
        store_id: storeId,
        data: cart,
      })
    );
  };

  const handleCategoryClick = (index: number) => {
    setSelectedCategoryId(index);

    const selectedElement = scrollRef.current?.children[index] as
      | HTMLDivElement
      | undefined;

    setIsScroll(true);

    clearTimeout(timer);
    timer = setTimeout(() => {
      setIsScroll(false);
    }, 1300);

    if (selectedElement) {
      window.scrollTo(0, window.scrollY);
      selectedElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const getCartData = async () => {
    const cartData = await AsyncLocalStorage.getItem("cart");
    console.log("cartData", cartData);
    if (
      cartData &&
      cartData.data.findIndex(
        (item: orderDetailRealmType) => item.store_id !== storeId
      ) === -1
    )
      setCart(cartData.data);
  };

  useEffect(() => {
    getStoreInfo();
    getCartData();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        const scrollElement = scrollRef.current;
        const children = scrollRef.current.children;

        for (let i = 0; i < children.length; i++) {
          const selectedCategoryElement = categoryScrollRef.current?.children[
            i
          ] as HTMLDivElement | undefined;

          const parentRect = scrollRef.current.getBoundingClientRect();
          const childRect = (
            children[i] as HTMLElement
          ).getBoundingClientRect();

          if (!isScroll) {
            if (
              scrollElement.scrollHeight - scrollElement.scrollTop <=
              scrollElement.clientHeight
            ) {
              setSelectedCategoryId(children.length - 1);
            } else if (childRect.bottom > parentRect.top) {
              setSelectedCategoryId(i);
              // console.log("selectedCategoryElement", selectedCategoryElement);

              if (selectedCategoryElement) {
                selectedCategoryElement.scrollIntoView({
                  behavior: "smooth",
                  block: "nearest",
                });
              }
              break;
            }
          }
        }
      }
    };

    const scrollElement = scrollRef.current;

    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
      return () => {
        scrollElement.removeEventListener("scroll", handleScroll);
      };
    }
  }, [storeInfo, isScroll]);

  const MenuListComponent = useMemo(() => {
    return (
      <div className="menuList">
        <div className="categoryWrap" ref={categoryScrollRef}>
          {storeInfo &&
            storeInfo.all.map((menu: CategoryType, index: number) => (
              <div
                key={index}
                className={`category ${
                  selectedCategoryId === index && "categoryActive"
                }`}
                onClick={() => handleCategoryClick(index)}
              >
                <h2 className="limitText">{menu.category_name}</h2>
              </div>
            ))}
        </div>
        <div className="menuListWrap" ref={scrollRef}>
          {storeInfo &&
            storeInfo.all.map((category: CategoryType, index: number) => (
              <div>
                <h1>{category.category_name}</h1>
                <div className="menu" key={index}>
                  {category.product_list.map(
                    (product: ProductType, prdIndex: number) => {
                      return (
                        <div
                          className="menuItem"
                          key={prdIndex}
                          onClick={() =>
                            checkCartOption(category.category_id, product)
                          }
                        >
                          <div className="menuImageWrap">
                            {product.url_path !== "" ? (
                              <img
                                src={
                                  product.url_path
                                    ? product.url_path
                                    : `${process.env.PUBLIC_URL}/svg/ic_none_image.svg`
                                }
                                alt="메뉴이미지"
                              />
                            ) : (
                              <div></div>
                            )}
                          </div>
                          <div className="menuInfo">
                            <h2 className="limitText">{product.prd_name}</h2>
                            <p>{product.prd_base_price_nrm}원</p>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }, [storeInfo, selectedCategoryId, cart]);

  const RenderCart = useMemo(() => {
    return (
      <div className="cartList">
        {cart &&
          cart.length > 0 &&
          cart.map((item: orderDetailRealmType, index: number) => {
            return (
              <div key={index} className="cartItem">
                <h1 className="name">{item.product_name}</h1>
                <div className="quantity">
                  <button
                    onClick={() =>
                      setQuantity(index, item.product_quantity - 1)
                    }
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/svg/ic_minus_box.svg`}
                      alt="minus"
                    />
                  </button>
                  <h1>{item.product_quantity}</h1>
                  <button
                    onClick={() =>
                      setQuantity(index, item.product_quantity + 1)
                    }
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/svg/ic_plus_box.svg`}
                      alt="plus"
                    />
                  </button>
                </div>
              </div>
            );
          })}
      </div>
    );
  }, [cart]);

  return (
    <>
      <Style>
        <div className="wrapper">
          <div className="header">
            <div className="storeInfo">
              <h3>
                준비
                <strong>{storeInfo && storeInfo.store_order_time_nrm}</strong>
              </h3>
              <h3>
                혼잡도
                <strong>{storeInfo && storeInfo.congestion_type_name}</strong>
              </h3>
              <h3>
                거리<strong>{storeInfo && storeInfo.store_distance}</strong>
              </h3>
            </div>
            <div className="storeTitle">
              <h1>{storeInfo && storeInfo.store_name}</h1>
              <button onClick={setFavorite}>
                {storeInfo && storeInfo.favorites_flag === 1 ? (
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_heartColor.svg`}
                    alt="heart"
                  />
                ) : (
                  <img
                    // src={`${process.env.PUBLIC_URL}/svg/ic_heart.svg`}
                    src={`${process.env.PUBLIC_URL}/svg/ic_heart_white.svg`}
                    alt="heart"
                  />
                )}
              </button>
            </div>
            {!visibleCart && (
              <button className="minicart" onClick={() => setVisibleCart(true)}>
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_cart.svg`}
                  alt="cart"
                  width="100%"
                  height="100%"
                />
                <div className="quantity">
                  <h2>{getCartLength(cart)}</h2>
                </div>
              </button>
            )}
            {/* <button className="call">
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_phone.svg`}
                alt="전화아이콘"
              />
            </button> */}
          </div>
          <div className="orderHistoryWrap">
            {MenuListComponent}
            <div className={`cart ${!visibleCart && "none"}`}>
              <div className="cartBox">
                <div className="leftWrap" onClick={() => setVisibleCart(false)}>
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_small_arrow_right.svg`}
                    alt="right_arrow"
                  />
                </div>
                <div className="rightWrap">
                  {RenderCart}
                  <div className="totalPrice">
                    <h1>합계</h1>
                    <h1>{getCartLength(cart)}개</h1>
                  </div>
                </div>
              </div>
              <button
                className="successButton"
                onClick={() => {
                  if (cart.length > 0) {
                    navigate("/order/payment");
                  } else {
                    showToast("상품을 담아주세요", "error");
                  }
                }}
              >
                주문하기
              </button>
            </div>
          </div>
        </div>
      </Style>
      <RecoilOptionModal />
    </>
  );
};

export default OrderMain;

const Style = styled.div`
  .wrapper {
    width: 100%;
    height: 100vh;
    padding: 5vh 0;
    display: flex;
    flex-direction: column;
  }
  .storeTitle,
  .storeInfo,
  .orderHistoryWrap {
    display: flex;
    align-items: center;
  }

  /* header */
  .header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 18px;
    gap: 30px;

    .storeTitle {
      justify-content: center;

      h1 {
        margin-right: 24px;
        font-size: 40px;
        font-weight: 500;
        white-space: nowrap;
      }
      img {
        width: 36px;
        height: 36px;
      }
    }
    .storeInfo {
      position: absolute;
      gap: 20px;
      left: 2%;
      h3 {
        font-size: 28px;
        font-weight: 500;
        white-space: nowrap;
        color: #979797;
        strong {
          margin-left: 10px;
          font-size: 28px;
          font-weight: 500;
          color: #6490e8;
        }
      }
    }
    /* button.call {
      position: absolute;
      right: 0;
      padding: 12px 32px;
      background: linear-gradient(
        180deg,
        #5d88de 0%,
        #09276e 100%,
        #8c8c8c 100.01%
      );
      border-radius: 10px;
    } */
  }

  /* orderHistoryWrap */
  .orderHistoryWrap {
    align-items: flex-start;
    height: 100%;
    width: 100%;
    overflow: hidden;
    gap: 30px;
  }
  /* overflow-y: scroll; */
  .menuList {
    height: 100%;
    display: flex;
    align-items: flex-start;
    gap: 30px;

    .categoryWrap {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 2vh;
      max-width: 16vw;
      overflow-y: auto;

      .category {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 9vh;
        min-height: 9vh;
        padding: 0 2vh;
        border: 1px solid #a7a7a7;
        border-radius: 20px;
      }
      .categoryActive {
        border: none;
        background: linear-gradient(180deg, #6490e8 0%, #001e62 100%);
      }
    }
    .menuListWrap {
      height: 100%;
      width: 100%;
      overflow-y: auto;

      h1 {
        margin: 14px 10px;
        font-weight: 600;
      }

      .menu {
        display: flex;
        align-items: stretch;
        justify-content: flex-start;
        flex-wrap: wrap;
      }
      .menuItem {
        width: 12.8vw;
        margin: 0 10px;
        margin-bottom: 19px;
        border: 1px solid #a7a7a7;
        border-radius: 10px;

        .menuImageWrap {
          width: 100%;
          height: 190px;

          img {
            width: 100%;
            height: 100%;
            background-size: stretch;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
          }
        }
        .menuInfo {
          padding: 8px 13px;
          border-top: 1px solid #eee;

          h2 {
            margin-bottom: 4px;
            font-size: 24px;
            font-weight: 500;
          }
          p {
            font-size: 20px;
            font-weight: 400;
            color: #a7a7a7;
          }
        }
      }
      .menuItem:active {
        outline: 5px solid #6490e8;
        background: linear-gradient(180deg, #5d88de 0%, #0a286f 100%);
      }
    }
  }
  .cart {
    max-width: 28vw;
    min-width: 28vw;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: max-width 0.3s ease, min-width 0.3s ease;

    .cartBox {
      height: 65vh;
      display: flex;
      border: 1px solid #ffffff;
      border-radius: 10px;
      .leftWrap {
        width: auto;
        display: flex;
        align-items: center;
        img {
          width: 36px;
          height: 36px;
        }
      }
      .rightWrap {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-left: 1px solid #ffffff;
        .cartList {
          width: 100%;
          overflow-y: auto;
        }
        .cartItem {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #ffffff;
          padding: 20px;
          gap: 20px;
          h1 {
            width: auto;
            font-weight: 500;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          h1.name {
            width: 260px;
          }
          .quantity {
            min-width: 38%;
            max-width: 38%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            button {
              width: auto;
            }
            img {
              width: 48px;
              height: 48px;
            }
          }
        }

        .totalPrice {
          border-radius: 0 0 10px 0;
          background: #242424;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 20px;
          padding-right: 100px;
          white-space: nowrap;
          h1 {
            width: auto;
            font-size: 40px;
            line-height: 56px;
            font-weight: 500;
          }
        }
      }
    }
  }
  .cart.none {
    max-width: 0;
    min-width: 0;
  }

  button.minicart {
    position: fixed;
    top: 2%;
    right: 7%;
    height: 10vh;
    aspect-ratio: 1/1;
    border-radius: 100%;
    background: linear-gradient(180deg, #5d88de 0%, #0a286f 100%);
    img {
      width: 50%;
      height: 50%;
    }
    .quantity {
      position: absolute;
      top: 0;
      right: 0;
      width: 40%;
      height: 40%;
      border-radius: 100px;
      background: #ffffff;
      border: 3px solid #6490e8;
      text-align: center;
      h2 {
        font-size: 3vh;
        line-height: 3.5vh;
        font-weight: 600;
        color: #6490e8;
      }
    }
  }

  .successButton {
    height: 12vh;
  }
`;
